import React, { useEffect } from 'react'
import './MyProfile.css'

import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import KeyIcon from '@mui/icons-material/Key'
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

import { Link,useHistory } from 'react-router-dom'
import RippleEffect from '../../../components/RippleEffect';
const MyProfile = () => {

  const history = useHistory();
  useEffect(() => {

  }, [])

  return <div className="rightside-container">
    <div className="card-row-container">
   
      <div className="card">
      <RippleEffect color="#309FDB40" to={()=>{
        history.push({ pathname: "/auth/change-password"})
      }}>
      {/*<Ripples color="#309FDB" during={1200}>*/}
        <a>
          <div className="title-spacer"></div>
          <div className="card-title circle-container"><div className="my-profile-icon1"><KeyIcon /></div><div>Password</div></div>
          {/* <div className="card-body">Last change on 3/30/2022 21:00.</div> */}
          <div className="card-body">Password expires every 90 days and cannot be changed for 1 day after the last change.</div>
        </a>
        {/*</Ripples>*/}
        </RippleEffect>
      </div>
      



      <div className="card">
      <RippleEffect color="#13B6CF40" to={()=>{ 
        // history.push({ pathname: "/auth/multi-factor-auth"})
          window.location.href = `${window.location.origin}/accountmanagementmfa/oauth2/authorization/oracle`
        }}>
        <a>
          <div className="title-spacer"></div>
          <div className="card-title circle-container"><div className="my-profile-icon2"><VerifiedUserIcon /></div><div>Two-step Verification</div></div>
          {/* <div className="card-body">Last change on 3/30/2022 21:00.</div> */}
          <div className="card-body">Keep your verification methods and security info up to date.</div>
        </a>
        </RippleEffect>
      </div>



      <div className="card">
      <RippleEffect color="#2EBFBC40" to={()=>{
           history.push({ pathname:"/auth/security-question"})
      }}>
        <a>
          <div className="title-spacer"></div>
          <div className="card-title circle-container"><div className="my-profile-icon3"><QuestionMarkIcon /></div><div>Security Question</div></div>
          {/* <div className="card-body">Last change on 2/20/2021 21:00.</div> */}
          <div className="card-body">Security questions are required to reset your password. Keep your security questions up to date.</div>
        </a>
        </RippleEffect>
      </div>


      <div className="card">
      <RippleEffect color="#3CAF8540" to={()=>{
         history.push({ pathname:"/auth/faqsauth"})
      }}>
        <a>
          <div className="title-spacer"></div>
          <div className="card-title circle-container"><div className="my-profile-icon4"><QuestionAnswerIcon /></div><div>FAQs</div></div>
          {/* <div className="card-body">Last change on 2/20/2021 21:00.</div> */}
          <div className="card-body">Common questions relating to account management and logging in.</div>
        </a>
        </RippleEffect>
      </div>
      
    </div>
    {/* <div>
      <div className="card"></div>
      <div className="card"></div>
      <div className="card"></div>
    </div> */}
  </div >

}

export default MyProfile